module.exports = __webpack_public_path__ + "assets/img/first-screenshot.8e2b124b.png";